// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__uaUg2","spinner":"Spinner_spinner__vtlHw","rotate":"Spinner_rotate__RjG+G"};